module.exports = __webpack_public_path__ + "img/Dog.593b316e.png";